export default __webpack_public_path__ + "static/Home-1920-f2a42c1ee00c6f3cfb51cd0cc80ab513.webp";